"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.getChartConfig = void 0;
exports.prettifyTooltipTitle = prettifyTooltipTitle;
exports.suggestedMax = suggestedMax;
exports.suggestedMin = suggestedMin;
exports.tooltipLabelCb = tooltipLabelCb;
exports.yGridColor = yGridColor;
exports.yTicksCallback = yTicksCallback;
var _valuationUtilsComponent = require("@cian/valuation-utils-component");
var _locale = require("date-fns/locale");
var _datasetUtils = require("./datasetUtils");
var _types = require("../types");
var _getChartData = require("./getChartData");
var _getAnnotations = require("./getAnnotations");
var _constants = require("./constants");
var _getCustoms = require("./getCustoms");
var _crosshairPlugin = require("./crosshairPlugin");
var _utils = require("./utils");
var _controlHoverStatePlugin = require("./controlHoverStatePlugin");
var _config = require("./config.setHoverEvents");
var _config2 = require("./config.pointRadius");
var _config3 = require("./config.setEvents");
var _dateFns = require("date-fns");
// eslint-disable-next-line import/no-duplicates

// eslint-disable-next-line import/no-duplicates

const getChartConfig = params => {
  const {
    props
  } = params;
  const {
    data: {
      xScale
    },
    convertToUTC,
    verticalPadding,
    maxYTicks,
    isDesktop
  } = props;
  const customs = (0, _getCustoms.getCustoms)(props);
  const xScaleRange = (0, _datasetUtils.prepareXScaleRange)(props, {
    convertToUTC
  });
  const cfg = {
    type: 'line',
    data: (0, _getChartData.getChartData)(params),
    options: {
      maintainAspectRatio: false,
      parsing: {
        xAxisKey: 'date',
        yAxisKey: 'price'
      },
      interaction: {
        intersect: false,
        mode: 'nearest',
        axis: 'x'
      },
      scales: {
        x: {
          type: 'time',
          suggestedMin: xScaleRange.dateMin,
          //границы, задающие временной интервал на оси Х
          suggestedMax: xScaleRange.dateMax,
          time: {
            unit: xScale,
            displayFormats: {
              month: 'LLL yy',
              day: 'dd MMM'
            },
            tooltipFormat: 'dd MMMM yyyy'
          },
          adapters: {
            date: {
              locale: _locale.ru
            }
          },
          ticks: {
            color: _constants.TICKS_FONT_COLOR,
            padding: 6,
            maxRotation: 0,
            autoSkipPadding: 20
          },
          grid: {
            drawOnChartArea: false,
            color: _constants.BORDER_COLOR,
            lineWidth: 1,
            borderColor: _constants.BORDER_COLOR,
            //цвет нижней границы графика
            tickColor: _constants.TICKS_COLOR,
            tickLength: 4
          }
        },
        y: {
          suggestedMin: (0, _utils.ensureScriptable)(suggestedMin(verticalPadding)),
          suggestedMax: (0, _utils.ensureScriptable)(suggestedMax(verticalPadding)),
          grid: {
            drawOnChartArea: true,
            drawBorder: false,
            drawTicks: false,
            color: yGridColor
          },
          ticks: {
            color: _constants.TICKS_FONT_COLOR,
            padding: 6,
            callback: tickValue => yTicksCallback(tickValue),
            count: maxYTicks || 3
          }
        }
      },
      elements: {
        point: {
          hoverBorderWidth: _constants.POINT_BORDER_WIDTH,
          hoverRadius: _constants.POINT_HOVER_RADIUS,
          borderColor: customs.BG_COLOR,
          borderWidth: _constants.POINT_BORDER_WIDTH
        },
        line: {
          borderWidth: 2
        }
      },
      plugins: {
        legend: {
          display: false
        },
        tooltip: {
          enabled: true,
          backgroundColor: '#152242',
          titleColor: 'rgba(255, 255, 255, 0.6)',
          cornerRadius: 4,
          caretSize: 0,
          caretPadding: 12,
          callbacks: {
            label: tooltipLabelCb
          },
          boxWidth: 7,
          boxHeight: 7,
          boxPadding: 4,
          usePointStyle: true
        },
        annotation: (0, _getAnnotations.getAnnotations)(props)
      },
      layout: {
        autoPadding: true,
        padding: {
          left: -2,
          right: 4
        }
      }
    },
    plugins: [(0, _crosshairPlugin.crosshairPlugin)(props.logger), (0, _controlHoverStatePlugin.getControlHoverStatePlugin)(isDesktop)]
  };
  (0, _config.setHoverEvents)(cfg, props);
  (0, _config2.setPointRadius)(cfg, props);
  (0, _config3.setEvents)(cfg, props);
  return cfg;
};
exports.getChartConfig = getChartConfig;
function yGridColor(ctx) {
  return ctx.index ? _constants.BORDER_COLOR : 'transparent';
}
function yTicksCallback(tickValue, type) {
  if (type === _types.EChartTypes.SupplyDemand) {
    return `${(0, _valuationUtilsComponent.getPrettyPrice)(Number(tickValue), {
      showUnit: false,
      showPostfix: false
    })}%`;
  }
  return (0, _valuationUtilsComponent.getPrettyPrice)(Number(tickValue), {
    showUnit: false,
    showPostfix: false
  });
}
function tooltipLabelCb(tooltipItem, activeFilter) {
  if (activeFilter === _types.ERoomsCount.All) {
    return tooltipItem.raw.prettyValue;
  }
  return (0, _valuationUtilsComponent.getPrettyPrice)(tooltipItem.parsed.y);
}
function prettifyTooltipTitle(tooltipItems) {
  const date = (0, _dateFns.format)(tooltipItems[0].parsed.x, 'LLLL yyyy', {
    locale: _locale.ru
  });
  return date.charAt(0).toUpperCase() + date.slice(1);
}
function suggestedMax(verticalPadding) {
  return ctx => {
    if (!verticalPadding) {
      return null;
    }
    const {
      min,
      max
    } = ctx.chart.data.datasetsXRange;
    return max + Math.abs(max - min) * verticalPadding;
  };
}
function suggestedMin(verticalPadding) {
  return ctx => {
    if (!verticalPadding) {
      return null;
    }
    const {
      min,
      max
    } = ctx.chart.data.datasetsXRange;
    const p = min - Math.abs(max - min) * verticalPadding;
    return p < 0 ? 0 : p;
  };
}